
<div class="mt-4"> 
<h5> <strong> Preferences</strong></h5>
<p style="color: #6D6D6D;"> Choose Your language</p>
<div class="container-fluid">
    <div class="row">
        <div class="col-10 d-flex justify-content-between    justify-content-center align-items-center           language"> 
            
            <div class="d-flex gap-3"> 
            <p style="color: #6D6D6D;"> Language</p>
            <p>English(US)</p>
            </div>
            <span  class="cursor"  data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" style="color:#309EAE">  Edit</span>
    </div>
</div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
  <div  class="offcanvas-header">
    <h5  *ngIf="!showsuccess" class="offcanvas-title" id="offcanvasRightLabel"> <strong> Edit language preference</strong></h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body  flex-column d-flex justify-content-between">
    
    <form  *ngIf="!showsuccess" >
        <div class="mb-3 ">
            <div class=" "> 
                <div>     <label for="exampleInputEmail1" class="form-label">language</label> </div>
      
                <div class="d-flex" style="position: relative; display: inline-block;">
                    <select class="form-control"  name="language"  [(ngModel)]="selectedLanguage"   id="languageSelect" style="appearance: none; padding-right: 30px;">
                      <option value="">English (US)</option>
                      <option value="fr">French</option>
                      <option value="es">Spanish</option>
                      <option value="de">German</option>
                      <option value="hi">Hindi</option>
                      <option value="zh">Chinese</option>
                      <option value="ar">Arabic</option>
                    </select>
                    <label for="languageSelect" >
                      <img class="arrowupdon" src="/assets/preferenceIcon/select.png" style="pointer-events: none;">
                    </label>
                  </div>
          </div>
        </div>
       
      </form>

             
      <div *ngIf="showsuccess" class="d-flex flex-column justify-content-center align-items-center min-vh-100">
        <img src="assets/settingIcon/image.png" alt="Success" style="max-width: 200px;" />
        <b class="mt-3">Language Preference Updated </b>
        
      </div>

      





      <button  *ngIf="!showsuccess" class="updatebtn"
      [class.highlight]="selectedLanguage" (click)="updatesuccessfully()"
      [disabled]="!selectedLanguage">
Update
</button>
  </div>





</div>